var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRefreshGray16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B9B6E408-E192-4E4A-9430-707F5198EF15_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Navigation",
    transform: "translate(-1233.000000, -191.000000)",
    stroke: "#C1C1C1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(1218.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Refresh_Gray-16px",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,5.05263158 C1.85263158,2.77894737 3.62105263,0 8.04210526,0 C12.4210526,0 16,3.57894737 16,8",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    points: "0 0.842105263 0 5.05263158 4.21052632 5.05263158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10.9473684 C14.1473684,13.1368421 12.3789474,16 7.95789474,16 C3.53684211,16 0,12.4210526 0,8.04210526 C0,8.04210526 0,8 0,8",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-7",
    points: "16 15.1578947 16 10.9473684 11.7894737 10.9473684"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefreshGray16Px);
export default __webpack_public_path__ + "static/media/Icon_Refresh_Gray-16px.2494732f320a7851ba0f7dca9f60f15e.svg";
export { ForwardRef as ReactComponent };